
import React, { useEffect, useState } from 'react';
import backend from '../../../../../../../api';
import Classes from '../../Workspace.module.css';
import { useSelector } from 'react-redux';
import PipelineMenu from './PipelineMenu';
import DropDown from './DropDown';
import convertToRgba from '../../../../../../../utils/colorUtils';

const staticOnboarding = {
  _id: "COMP123",
  color: "#3e9bff",
  scoringCriteria: [
    { name: "deckStructure", status: true },
    { name: "marketOpportunity", status: true }
  ]
};

export default function PipelineCard({
  data,
}) {
  const onBoarding = useSelector((state) => state.companyInfo.info);
  const [status, setStatus] = useState(data.projectStatus);

  return (
    <div className={Classes.cardBox} style={{ backgroundColor: convertToRgba('rgb(62, 155, 255)', 0.03) }} >
      <div className={Classes.flexBetween}>
        <div className={Classes.flexAlign7}>
          <h5 className={Classes.titleMini2}>
            {data.project}
          </h5>
          <DropDown
            selectedValue={status}
            options={["Submitted", "Working"]}
            onChange={setStatus}
            isDropDown={true}
          />
        </div>
        {/* <h5 className={Classes.textMiniLight}>
          in this stage
        </h5> */}
        <PipelineMenu />
      </div>
      <hr className={Classes.line} />
      <div className={`${Classes.flexBetween} ${Classes.mb10}`}>
        <h5 className={Classes.titleMini}>Order started</h5>
        <h5 className={Classes.textLight}>{data.orderStarted}</h5>
      </div>
      <div className={Classes.flexBetween}>
        <h5 className={Classes.titleMini}>Order due</h5>
        <h5 className={Classes.textLight}>{data.orderDue}</h5>
      </div>
      <hr className={Classes.line} />
      <h5 className={Classes.titleMini}>Tasks</h5>
      {data.tasks && data.tasks.length > 0 &&
        <>
          {data.tasks.map((task, ind) => {
            return (
              <div className={`${Classes.flexBetween} mt-10 mb-10`} key={ind} >
                <h5 className={Classes.textMiniLight}> {task.name} </h5>
                <DropDown
                  selectedValue={task.status}
                  options={["Submitted", "Working"]}
                  onChange={(value) => task.status = value}
                  isDropDown={true}
                />
              </div>
            )
          }
          )}
        </>
      }
      <hr className={Classes.line} />
      <h5 className={Classes.titleMini}>Forms</h5>
      {data.forms && data.forms.length > 0 &&
        <>
          {data.forms.map((form, ind) => {
            return (
              <div className={`${Classes.flexBetween} mt-10 mb-10`} key={ind} >
                <h5 className={Classes.textMiniLight}> {form.name} </h5>
                <DropDown
                  selectedValue={form.status}
                  options={["Submitted", "In progress"]}
                  onChange={(value) => form.status = value}
                  isDropDown={true}
                />
              </div>
            )
          })}
        </>
      }

      <hr className={Classes.line} />
      <h5 className={Classes.titleMini}>Tickets</h5>
      {data?.tickets && data.tickets.length > 0 ?
        <>
          {data.tickets.map((ticket, ind) => {
            return (
              <>
                <div className={`${Classes.flexBetween} mt-10 mb-10`}>
                  <h5 className={Classes.textMiniLight}> {ticket.message} </h5>
                  <h5 className={Classes.textBtn} style={{ color: staticOnboarding.color }} > View </h5>
                </div>
              </>
            )
          })}
          <h5 className={Classes.textBtn} style={{ color: staticOnboarding.color }} > Add ticket </h5>
        </>
        :
        <div className={`${Classes.flexBetween} mt-10`} >
          <h5 className={Classes.textMiniLight}>No tickets yet</h5>
          <h5 className={Classes.textBtn} style={{ color: staticOnboarding.color }} > Add ticket </h5>
        </div>
      }
      <hr className={Classes.line} />
      <h5 className={Classes.titleMini}>Notes</h5>
      {data?.notes && data.notes.length > 0 ?
        <>
          {data.notes.map((note, ind) => {
            return (
              <>
                <div className={`${Classes.flexBetween} mt-10 mb-10`}>
                  <h5 className={Classes.textMiniLight}> {note.message} </h5>
                  <h5 className={Classes.textBtn} style={{ color: staticOnboarding.color }} > View </h5>
                </div>
              </>
            )
          })}
          <h5 className={Classes.textBtn} style={{ color: staticOnboarding.color }} > Add note </h5>
        </>
        :
        <div className={`${Classes.flexBetween} mt-10`} >
          <h5 className={Classes.textMiniLight}> No notes yet </h5>
          <h5 className={Classes.textBtn} style={{ color: staticOnboarding.color }} > Add note </h5>
        </div>
      }
    </div >
  );
}
